import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { CategoryGroupQueryDto } from './categroy-group-query.dto';
import { DepartmentDto } from '../../administration/department/department.dto';

@Api('api/app/category-group')
export class CategoryGroupDto extends DtoHasApi {
  id: number;
  name: string;
  categoryColor: string;
  categoryTypeId: number;
  departmentId: number;
  categoryGroupQueries: CategoryGroupQueryDto[] = [];
  department: DepartmentDto;
}
